import { Button, ButtonRow, Card, FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import type { IStepProps } from '../NewGhcRequest';
import { translateKey } from '../../../../translate';

export function Step1(props: IStepProps) {
    const getTelephoneNumberError = () => {
        const error = props.errors.get('phoneNumber');
        if (!error) {
            return undefined;
        }
        if (error === 'string_pattern.base') {
            return translateKey('validation.invalidPhoneNumber');
        }

        return translateKey('validation.' + error);
    };

    const title = props.request.procedureId
        ? 'Op welk telefoonnummer kan de arts je bereiken?'
        : 'Geef je e-mail en telefoonnummer door zodat een zorgverlener je kan bereiken.';

    return (
        <>
            <Card.Header title={title} />
            <Card.Body>
                <FormSection>
                    {!props.request.procedureId && (
                        <FormGroup
                            hasErrors={props.errors.has('email')}
                            label="E-mailadres"
                        >
                            <TextInput
                                error={
                                    props.errors.get('email')
                                        ? translateKey('validation.' + props.errors.get('email'))
                                        : undefined
                                }
                                onChange={(e) => props.handleChange({ email: e.target.value })}
                                placeholder="Voer je e-mailadres in..."
                                value={props.request.customControlData.email || ''}
                            />
                        </FormGroup>
                    )}
                    <FormGroup
                        hasErrors={props.errors.has('phoneNumber')}
                        label="Telefoonnummer"
                    >
                        <TextInput
                            error={getTelephoneNumberError()}
                            onChange={(e) => props.handleChange({ phoneNumber: e.target.value })}
                            placeholder="Ik ben overdag bereikbaar op..."
                            value={props.request.customControlData.phoneNumber}
                        />
                    </FormGroup>
                </FormSection>
                <FormSection isBorderless>
                    <ButtonRow justify="center">
                        <Button
                            onClick={props.validateAndGoToNextStep}
                            type="button"
                            variant="solid"
                        >
                            Volgende
                        </Button>
                    </ButtonRow>
                </FormSection>
            </Card.Body>
        </>
    );
}
